<template>
  <div>
    <FormManager
        :prettyEndPoint="'/api/form/' + form_id"
        @submit="submit"
        :events="events"
    ></FormManager>
  </div>
</template>

<script>
export default {
  name: "FormJson",
  props: ['form_id'],
  methods: {
    submit() {
      console.log()
    }
  },
  data() {
    return {
      events: {
        submit: {
          label: "Submit",
          event: "submit"
        },
      }
    }
  },
}
</script>

<style scoped>

</style>